// @ts-nocheck
$(document).ready(() => {
    // Fix for Edge autoplay
    const videoElem = document.querySelector('.b-hero_carousel video[autoplay]');

    if (videoElem && videoElem.play) {
        videoElem.play();
    }
});
